import { render } from "./instance_specific_panel.vue?vue&type=template&id=707b4e95"
import script from "./instance_specific_panel.js?vue&type=script&lang=js&external"
export * from "./instance_specific_panel.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__